import React from 'react'
import { createRoot } from 'react-dom/client'
import { PaymentsTable } from './components/PaymentsTable'

// Mount point: <div id="…" data-url="…" data-email="…"> (read from data attributes so nothing is interpolated into JS)
export const startSupportPaymentsTable = elementId => {
  const element = document.getElementById(elementId)
  const root = createRoot(element)
  root.render(
    <PaymentsTable
      dataUrl={element.dataset.url}
      email={element.dataset.email}
    />
  )
}
